import { render, staticRenderFns } from "./UserPlaceholder.vue?vue&type=template&id=538c905c&scoped=true&"
import script from "./UserPlaceholder.vue?vue&type=script&lang=js&"
export * from "./UserPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./UserPlaceholder.vue?vue&type=style&index=0&id=538c905c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c905c",
  null
  
)

export default component.exports